import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Layout } from 'blaze-validator';
import { searchOffer } from './layouts';
import OfferList from './OfferList';
import Form from '../form/Form';

const OfferSearch = ({ initialCustomerId = '', initialOffersSelected = [], initialSearch, onSelect }) => {
  const [currentSearch, setCurrentSearch] = useState({});
  const [showSearch, setShowSearch] = useState(true);
  const [customerId, setCustomerId] = useState(initialCustomerId);

  const firstUpdate = useRef(true);

  const layout = new Layout(searchOffer);

  const handleSubmit = payload => {
    const params = {};

    setCustomerId(payload.externalCustomerId);

    // Just remove empty strings
    Object.keys(payload).forEach(f => {
      if (payload[f] !== '') {
        if (typeof payload[f] === 'boolean') {
          if (payload[f]) {
            params[f] = true;
          }
          return;
        }

        params[f] = payload[f];
      }
    });

    setCurrentSearch(params);
    setShowSearch(false);
  };

  const buildQuery = () => {
    const query = [];

    Object.keys(currentSearch).forEach(k => {
      if (k === 'externalCustomerId') {
        return;
      }

      const { label } = layout.lookup[k];
      query.push({
        label,
        value: currentSearch[k],
      });
    });

    return query;
  };

  useEffect(() => {
    if (firstUpdate.current) {
      if (initialSearch) {
        handleSubmit(initialSearch);
      }
      firstUpdate.current = false;
    }
  }, []);

  const className = classNames({
    'loyalty-offer-search': true,
  });

  return (
    <div className={className}>
      {!showSearch ? (
        <OfferList
          customerId={customerId}
          initialOffersSelected={initialOffersSelected}
          params={currentSearch}
          query={buildQuery()}
          onQueryClick={() => setShowSearch(true)}
          onSelect={onSelect}
        />
      ) : (
        <Form
          layout={layout.populateLayout({ ...currentSearch, externalCustomerId: customerId }).getLayout()}
          exportFormat="object"
          submit={handleSubmit}
          submitAll
          hideCancel
          feedback="none"
          trackDirty={false}
        />
      )}
    </div>
  );
};

OfferSearch.propTypes = {
  initialCustomerId: PropTypes.string,
  initialOffersSelected: PropTypes.array,
  initialSearch: PropTypes.object,
  onSelect: PropTypes.func,
};

export default OfferSearch;
